var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBtc = function SvgBtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 12.418c-1.335 5.36-6.766 8.619-12.118 7.283C2.222 18.364-1.037 12.934.3 7.58A9.994 9.994 0 0 1 12.419.3c5.352 1.328 8.618 6.758 7.282 12.118Z",
    fill: "url(#BTC_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.761 8.754c.196-1.328-.812-2.047-2.203-2.524l.453-1.804-1.093-.274-.438 1.758c-.29-.07-.586-.14-.883-.203l.438-1.766-1.094-.273-.445 1.797c-.243-.055-.477-.11-.704-.164v-.008l-1.515-.375-.29 1.172s.813.187.798.195c.445.11.523.406.507.64L7.777 8.98c.031.008.07.016.117.04a.65.65 0 0 1-.117-.032l-.719 2.875c-.055.133-.195.336-.5.258.008.016-.797-.195-.797-.195l-.547 1.258 1.43.359c.266.07.523.133.781.203l-.453 1.82 1.094.274.453-1.805c.297.078.594.156.875.227l-.445 1.797 1.094.273.453-1.82c1.875.351 3.28.21 3.867-1.485.476-1.359-.024-2.148-1.008-2.664.726-.164 1.266-.64 1.406-1.61Zm-2.508 3.516c-.335 1.359-2.632.625-3.375.437l.602-2.414c.742.188 3.133.555 2.773 1.977Zm.344-3.54c-.312 1.243-2.219.61-2.836.454l.547-2.188c.617.156 2.61.445 2.29 1.734Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "BTC_svg__a",
    x1: 9.995,
    y1: -0.005,
    x2: 9.995,
    y2: 19.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })))));
};
export default SvgBtc;